module.exports = __webpack_public_path__ + "img/product_98.0eb97c6.svg";